import { Helmet } from 'react-helmet';
import StepWizard from '../../../commons/StepWizard/StepWizard';
import { loginDIRSteps } from './LoginDIR.data';

export default () => {
  return (
    <>
      <Helmet>
        <title>Connexion Directeur Commercial</title>
      </Helmet>
      <StepWizard steps={loginDIRSteps} />
    </>
  );
};
